import React from "react";
import { PieChart } from 'react-minimal-pie-chart';

const MovimentationGraph = props => {
    
    return (
        <div style={{
            width: '100%',
            height: !props.unique ? '299px': '',
            display: 'flex',
            justifyContent: 'center'
        }}>
            <div style={{ width: '60%' }}>
                <PieChart
                    data={props.data}
                    lineWidth={35}
                    label={(labelProps) =>
                        <>
                            {labelProps.dataIndex === 0 ? (
                                <text
                                    dominant-baseline="central"
                                    x={labelProps.x}
                                    y={labelProps.y}
                                    dx={labelProps.dx}
                                    dy={labelProps.dy}
                                    style={{ fontSize: '10px', fontWeight: 'bold', fill: 'var(--txt-color)' }}
                                    text-anchor={labelProps.textAnchor}>
                                    {props.total}
                                </text>

                            ) : null}
                        </>
                    }
                    labelPosition={'0'}
                />
            </div>
        </div>
    )
}

export default MovimentationGraph